import { render, staticRenderFns } from "./WaiverDetail.vue?vue&type=template&id=6ebf01e2"
import script from "./WaiverDetail.vue?vue&type=script&lang=js"
export * from "./WaiverDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports